/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import template from './report-schedule-recipients-modal.component.html';
import {UserResource} from '../../components/api/resources/resource/user.resource';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

export interface ReportScheduleRecipientsModalResult {
  recipientUsers: any[];
  success?: boolean;
  validationWarnings?: any;
}

@Component({
  standalone: false,
  selector: 'adn-report-schedule-recipients-modal',
  template
})
export class ReportScheduleRecipientsModalComponent implements OnInit {
  recipientUsers: any[] = [];
  isNew = false;
  scheduleModel: any;
  salespersonId?: string;
  adOpsId?: string;

  readonly onClosed = new Subject<ReportScheduleRecipientsModalResult | void>();

  allUsers: any[] | null = null;
  selUsers: string[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(UserResource) private readonly User: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.selUsers = _.map(this.recipientUsers || [], 'id');
    this.User.query({minimal: true}, (page: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.allUsers = page.results || [];
      });
    });
  }

  isSelected(userId: string): boolean {
    return this.selUsers.includes(userId);
  }

  toggleUser(userId: string): void {
    const idx = this.selUsers.indexOf(userId);
    if (idx >= 0) {
      this.selUsers.splice(idx, 1);
    } else {
      this.selUsers.push(userId);
    }
  }

  save(): void {
    const recipientUsers = _.filter(_.map(this.selUsers, (userId) => {
      return _.find(this.allUsers, ['id', userId]);
    }), (user) => {
      return user && !!user.id;
    });

    if (!this.isNew && this.scheduleModel?.savePartial) {
      this.scheduleModel.recipientUsers = recipientUsers;
      this.scheduleModel.savePartial('recipientUsers').then((savedSchedule: any) => {
        deferMarkForCheck(this.cdr, () => {
          this.onClosed.next({
            recipientUsers,
            success: true,
            validationWarnings: savedSchedule?.validationWarnings
          });
          this.bsModalRef.hide();
        });
      }, () => {
        deferMarkForCheck(this.cdr, () => {
          this.onClosed.next({recipientUsers, success: false});
          this.bsModalRef.hide();
        });
      });
      return;
    }

    deferMarkForCheck(this.cdr, () => {
      this.onClosed.next({recipientUsers});
      this.bsModalRef.hide();
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
